import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const Suppliers = () => {
  const [suppliers, setSuppliers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [deleting, setDeleting] = useState(false);
  const [deleteError, setDeleteError] = useState('');

  const suppliersPerPage = 12;
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // Fetch suppliers from backend
  useEffect(() => {
    const fetchSuppliers = async () => {
      try {
        const res = await fetch("https://backend-zkgn.onrender.com/api/suppliers");
        if (!res.ok) throw new Error("Failed to fetch suppliers");
        const data = await res.json();
        setSuppliers(data);
        setLoading(false);
      } catch (err) {
        console.error(err);
        setError(err.message);
        setLoading(false);
      }
    };

    fetchSuppliers();
  }, []);

const handleDelete = async (supplier_id) => {
  const confirmDelete = window.confirm('Are you sure you want to delete this supplier?');
  if (!confirmDelete) return;

  try {
    setDeleting(true);
    const res = await fetch(`https://backend-zkgn.onrender.com/api/suppliers/${supplier_id}`, {
      method: 'DELETE'
    });

    if (!res.ok) throw new Error('Failed to delete supplier');

    // Remove deleted supplier from the list
    setSuppliers((prev) => prev.filter(supplier => supplier.supplier_id !== supplier_id));
  } catch (err) {
    console.error('Delete error:', err.message);
    setDeleteError('Error deleting supplier. Please try again.');
  } finally {
    setDeleting(false);
  }
 
};

  const indexOfLastSupplier = currentPage * suppliersPerPage;
  const indexOfFirstSupplier = indexOfLastSupplier - suppliersPerPage;
  const currentSuppliers = suppliers.slice(indexOfFirstSupplier, indexOfLastSupplier);
  const totalPages = Math.ceil(suppliers.length / suppliersPerPage);

  const handlePageChange = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  return (
    <div className="container-fluid my-5">
      <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
        <h5 className="fw-bold text-tertiry mb-2">
          <strong>{suppliers.length}</strong> - Suppliers Found
        </h5>
        <Link to="/addnewsupplier" className="btn btn-primary">
          Add New Supplier
        </Link>
      </div>

      {loading ? (
        <p>Loading suppliers...</p>
      ) : error ? (
        <p className="text-danger">Error: {error}</p>
      ) : (
        <>
          <div className="row">
            {currentSuppliers.map((supplier, index) => (
              <div key={supplier.id || index} className="col-lg-4 col-md-6 mb-4">
                <div className="card shadow-sm supplier-card position-relative h-100">
                  <div className="card-body">
                    <h5 className="card-title mb-2">
                      <strong>{supplier.supplier_name}</strong>
                    </h5>
                    <p className="card-text plantdetails mb-1">
                      <span className="label" style={{ color: "#D84D10" }}><strong>Address:</strong></span> {supplier.city}
                    </p>
                    <p className="card-text plantdetails mb-1">
                      <span className="label" style={{ color: "#D84D10" }}><strong>We are providers of:</strong></span> {supplier.providers_of}
                    </p>
                  </div>

                  <div className="position-absolute bottom-0 end-0 p-2 d-flex">
                    <Link to={`/editsupplier/${supplier.supplier_name.replace(
                    /\s+/g,
                    "-"
                  )}/${supplier.supplier_id || index}`} className="btn btn-link text-success p-0 me-3">
                      <i className="fa fa-edit"></i>
                    </Link>
                    <button
                      onClick={() => handleDelete(supplier.supplier_id)}
                      className="btn btn-link text-danger p-0"
                      disabled={deleting}
                      title="Delete Supplier"
                    >
                      <i className="fa fa-trash"></i>
                      {deleteError && <p className="text-danger text-center">{deleteError}</p>}
                    </button>
                    

                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="pagination-container d-flex justify-content-center mt-4 flex-wrap">
            <button className="pagination-btn" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
              Previous
            </button>

            {Array.from({ length: totalPages }, (_, index) => (
              <button
                key={index + 1}
                className={`pagination-btn ${currentPage === index + 1 ? "active" : ""}`}
                onClick={() => handlePageChange(index + 1)}
              >
                {index + 1}
              </button>
            ))}

            <button className="pagination-btn" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
              Next
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default Suppliers;
